import { Injectable } from "@angular/core";
import {
  Event as RouterEvent,
  NavigationEnd,
  NavigationExtras,
  NavigationStart,
  Router,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class PreviousPageService {
  id: number;
  previousUrl: string;
  currentUrl: string;
  extras: NavigationExtras;

  constructor(private router: Router) {
    this.registerHandler();
  }

  public registerHandler() {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      const currentNav = this.router.getCurrentNavigation();
      this.id = currentNav.id;

      this.extras = currentNav.extras;
    }

    if (event instanceof NavigationEnd) {
      if (event.id !== this.id) {
        console.warn(
          `Skipping NavigationEnd bc event.id mismatch (${this.id} versus ${event.id})`,
        );
        return;
      }
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
    }
  }
}
